import { Rate, Text } from "@tblabs/truffle";
import { Product } from "../../../Models/Product/Product";
import { Box } from "./Box";


export class ProductRating extends Box
{
    constructor(product: Product)
    {
        const rating = product.Rating.Plus(1); // ex. 4.93 = 5 stars, not 4

        super("product__rating", [
            new Rate(rating, { SelectedSymbol: "⭐", DeselectedSymbol: "⭐", Count: 5, Readonly: true, DeselectedStyle: "opacity: 0.3" }).Class("product__rating-stars"),
            new Text(product.Rating, v => v + "/5").Class("product__rating-score"),
        ]);
    }
}
